import React, { Component, Fragment } from "react";
import { properties } from "../../../../constants/Propertise";
import { Input } from "reactstrap";
import InlineError from "../../../InlineError";
import { api } from "../../../../api/api";

import "react-picky/dist/picky.css";
import AlertMessages from "../../../AlertMessages";
import Overlay from "../../../Overlay";
// import history from "../../../history";
// import CreatableSelect from "react-select/creatable";

class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      isValid: false,
      allOidDesc: [],
      AllUsersInformation: this.props.DeleteUsersData,
      // AllUsersInformationBeforeUpdate: this.props.AllUsersData,
      AllUsersToDeleteID: this.props.AllUsersToDeleteIDData,
      selectedFile: null,
      allVendorsList: [],
      allKpiGroups: [],
      allFormulasList: [],
      toolTipOpen: false,
      showNewPassword: false,
      showAdminPassword: false,
      adminPasswordd: "",
      userName: "",
      newPassword: "",
      reEnterNewPassword: "",
      passwordResetByAdminApiResponse: "",
      isSuccess: false,
      isPending: false,
      apiError: false,
      showAlertModal: false,
      message: "",
    };
  }
  componentDidMount = (event) => {
    console.log(this.state.AllUsersInformation);
    console.log(this.props.AllUsersToDeleteID);
  };

  validate = (data) => {
    let errors = {};

    // if (!data.adminPassword) {
    //     errors.adminPasswordd = "Admin Password is Required"
    // }
    // if (!data.userNametoBeDeleted) {
    //     errors.userName = "User Name is Required"
    // }

    return errors;
  };

  handleShowAdminPassword() {
    this.setState({ showAdminPassword: !this.state.showAdminPassword });
  }
  handleShowNewPassword() {
    this.setState({ showNewPassword: !this.state.showNewPassword });
  }

  handleFromSubmit = (event) => {
    event.preventDefault();
  };
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  passwordResetByAdminUser = (id) => {
    let idToDeleteURL =
      process.env.REACT_APP_JavaAPI_URL + "lms/base/deleteUser/" + id;
    this.setState({
      isSuccess: false,
      isPending: true,
      apiError: false,
      message: "Please Wait ...",
    });
    api
      .deleteJava(idToDeleteURL)
      .then((deleteResult) => {
        console.log(deleteResult.data.message);
        if (deleteResult.data !== undefined) {
          this.setState(
            {
              message: deleteResult.data.message,
              isSuccess: true,
              isPending: false,
              apiError: false,
            },
            () => {
              setTimeout(() => {
                this.props.updateTable();
              }, 2000);
            }
          );
          console.log(this.state.passwordResetByAdminApiResponse);
        } else {
          this.setState({
            message: deleteResult.data.message,
            isSuccess: false,
            isPending: false,
            apiError: true,
          });
        }
      })
      .catch((error) => {
        this.setState({
          message: error,
          isSuccess: false,
          isPending: false,
          apiError: true,
        });
      });

    this.setState({
      showAlertModal: true,
    });
  };
  handleSubmit = (event) => {
    event.preventDefault();

    let data = {
      userID: this.state.AllUsersToDeleteID,
      userNametoBeDeleted: this.state.AllUsersInformation,
    };

    const errors = this.validate(data);
    this.setState(
      {
        errors: errors,
      },
      () => {
        if (Object.keys(this.state.errors).length === 0) {
          this.passwordResetByAdminUser(this.state.AllUsersToDeleteID);
        }
      }
    );
  };

  closeAlertModal = () => {
    this.setState({
      showAlertModal: false,
    });
  };

  handleFileDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    this.setState({ selectedFile: file });
  };

  handleFileInputChange = (e) => {
    const file = e.target.files[0];
    this.setState({ selectedFile: file });
  };
  render() {
    return (
      // <Fragment>Delete</Fragment>
      <Fragment>
        <div className="mb-3">
          <form onSubmit={this.handleFromSubmit} autoComplete="off">
            <div className="form-row">
              <div className="col-md-6">
                <div
                  className="drop-area dropArea"
                  onDrop={this.handleFileDrop}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <p>Drag and drop file here</p>
                  <input
                    type="file"
                    id="fileInput"
                    className="d-none"
                    onChange={this.handleFileInputChange}
                  />
                  <label htmlFor="fileInput" className="btn btn-primary">
                    Browse Files
                  </label>
                </div>
                {this.state.selectedFile && (
                  <div>
                    <p>
                      Selected file: <b>{this.state.selectedFile.name}</b>
                    </p>
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <Input
                  type="text"
                  name="userName"
                  value={this.state.AllUsersInformation}
                  onChange={this.handleChange}
                  placeholder="Type your message here..."
                  style={{ width: "402px", height: "90px" }}
                />
                {this.state.errors.userName && (
                  <InlineError text={this.state.errors.userName} />
                )}
              </div>
            </div>
          </form>
        </div>
        {this.state.selectedFile && (
          <div>
            <strong>{this.state.passwordResetByAdminApiResponse}</strong>
            <div className="mb-0">
              <button
                className="btn btn-primary pull-right"
                type="submit"
                onClick={this.handleSubmit}
              >
                {properties.submitButtonText}
              </button>
            </div>
          </div>
        )}

        <Overlay
          openOverlay={this.state.showAlertModal}
          closeOverlay={this.closeAlertModal}
          className="alertData"
        >
          <AlertMessages
            isSucess={this.state.isSuccess}
            isPending={this.state.isPending}
            apiError={this.state.apiError}
            message={this.state.message}
            showAlert={this.state.showAlertModal}
            closeAlert={this.closeAlertModal}
          />
        </Overlay>
      </Fragment>
    );
  }
}

export default UploadFile;
